<p-dialog
  header="CAD Input"
  [visible]="visible"
  (visibleChange)="onVisibleChange($event)"
  [modal]="true"
  [style]="{ width: '90rem', maxWidth: '96vw', height: '90vh' }"
  [contentStyle]="{
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 auto',
    minHeight: '0',
    overflow: 'hidden',
  }"
  [draggable]="false"
  [resizable]="false"
  appendTo="body"
>
  @if (loading()) {
    <div class="flex items-center justify-center gap-2 py-12">
      <i class="pi pi-spin pi-spinner text-primary"></i>
      <span class="text-sm text-muted-color">Loading CAD geometry...</span>
    </div>
  } @else if (details(); as details) {
    <p class="mb-4 mt-0 text-sm leading-6 text-muted-color">
      The part CAD this moulding flow is built from. The selected object is the
      starting geometry for every downstream step.
    </p>
    <div class="flex min-h-0 flex-1 flex-col gap-4 lg:flex-row">
      <div class="flex min-h-0 flex-[3_1_0%] flex-col gap-4">
        <div
          class="min-h-0 flex-[3_1_0%] overflow-hidden rounded-lg border border-surface-switch-200"
        >
          <app-cad-viewer
            [cadObjects]="[details.cadObject]"
            [visibleCadObjectIds]="visibleCadObjectIds"
            [externallyHoveredCadObjectId]="hoveredCadObjectId"
            (hoveredCadObjectIdChange)="hoveredCadObjectId = $event"
          />
        </div>
        <app-cad-object-tree
          class="block min-h-0 flex-[2_1_0%]"
          [cadObjects]="[details.cadObject]"
          [primaryCadObjectId]="details.cadObject.id"
          [cadFileId]="details.cadFileId"
          [hoveredCadObjectId]="hoveredCadObjectId"
          (hoveredCadObjectIdChange)="hoveredCadObjectId = $event"
          (visibleCadObjectIdsChange)="visibleCadObjectIds = $event"
        />
      </div>
      <section
        class="flex min-h-0 flex-[2_1_0%] flex-col overflow-hidden rounded-lg border border-surface-switch-200 bg-surface-switch-0 p-4 lg:w-[30rem]"
      >
        <div class="border-b border-surface-switch-200 pb-3">
          <p class="m-0 text-sm font-medium text-surface-switch-900">
            {{ details.filename }}
          </p>
          <p class="mb-0 mt-1 text-sm text-muted-color">
            {{
              details.cadObject.name ||
                details.cadObject.step_ident ||
                "Object " + details.cadObject.index
            }}
          </p>
        </div>
        <div class="min-h-0 flex-1 overflow-y-auto">
          <app-cad-properties [cadObject]="details.cadObject" />
        </div>
      </section>
    </div>
  }

  <ng-template pTemplate="footer">
    <div class="flex justify-end gap-2">
      <p-button
        label="Close"
        severity="secondary"
        [outlined]="true"
        (onClick)="onVisibleChange(false)"
      />
      @if (!loading()) {
        <span
          [pTooltip]="
            processing.downstreamExecutionActive()
              ? 'Downstream steps are running. Wait for the sequence to finish.'
              : undefined
          "
          tooltipPosition="top"
        >
          <p-button
            label="Re-upload CAD"
            [disabled]="!canChangeCad"
            (onClick)="openPicker()"
          />
        </span>
      }
    </div>
  </ng-template>
</p-dialog>

<app-cad-input-picker-dialog
  [nodeId]="nodeId"
  [visible]="pickerVisible()"
  (visibleChange)="onPickerVisibleChange($event)"
  (configured)="onConfigured()"
/>
